module.exports = __webpack_public_path__ + "img/wash.369925fd.png";